"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var UsernameButton = _styledComponents["default"].button.attrs(function () {
  return {
    type: "button",
    className: "btn btn-sm btn-link",
    id: "dropdownMenuButton best-username-dropdown",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": "false"
  };
}).withConfig({
  displayName: "NavbarUsernameDropdown__UsernameButton",
  componentId: "sc-3rz59h-0"
})(["&&&{text-decoration:none !important;color:", ";}"], function (props) {
  return props.color ? props.color : props.theme["mlb-blue"];
});

var DropdownCaret = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "NavbarUsernameDropdown__DropdownCaret",
  componentId: "sc-3rz59h-1"
})(["color:", ";"], function (props) {
  return props.color ? props.color : props.theme["mlb-blue"];
});

var NavbarUsernameDropdown = function NavbarUsernameDropdown(_ref) {
  var username = _ref.username,
      children = _ref.children,
      color = _ref.color;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return _react["default"].createElement("span", null, _react["default"].createElement(UsernameButton, {
    color: color
  }, username, " \xA0 ", _react["default"].createElement(DropdownCaret, {
    color: color,
    iconName: "fa-angle-down",
    className: "fa-sm"
  })), _react["default"].createElement("div", {
    className: "dropdown-menu",
    "aria-labelledby": "dropdownMenuLink"
  }, children));
};

NavbarUsernameDropdown.propTypes = {
  username: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  color: _propTypes["default"].string
};
NavbarUsernameDropdown.defaultProps = {
  username: "",
  children: null,
  color: null
};
var _default = NavbarUsernameDropdown;
exports["default"] = _default;